import { extend } from 'lodash'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	Context: null,
	documentDetail: {},
	documentForm: {},
}

const { actions, reducer } = createSlice({
	name: 'contextAi',
	initialState,
	reducers: {
		uploadContextAiFile: (state, { payload }) =>
			extend(state, {
				Context: payload.context,
			}),
		removeContextAiFile: (state) =>
			extend(state, {
				Context: null,
			}),
		uploadThreadId_DocumentDetail: (state, { payload }) => {
			state.documentDetail = {
				...state.documentDetail,
				...payload,
			}
		},
		uploadThreadId_DocumentForm: (state, { payload }) => {
			state.documentForm = {
				...state.documentForm,
				...payload,
			}
		},
	},
})

export const {
	uploadContextAiFile,
	removeContextAiFile,
	uploadThreadId_DocumentDetail,
	uploadThreadId_DocumentForm,
} = actions

export default reducer
